import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ItemsRecalleds from './components/ItemsRecalleds';

const itemsRecalleds = (props,{ t }) => (
  <Container>
    <ItemsRecalleds {...props} />
  </Container>
);

itemsRecalleds.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(itemsRecalleds);
